import { useState, useEffect } from 'react';
import { useAccount, useMsal } from '@azure/msal-react';
import { getAuthenticatedClient } from '../Utils/tokenHelper';
import { enableFrontdoor } from '../Utils/features';

const BASE_URL = enableFrontdoor ? process.env.REACT_APP_PRICER_API_BASE_URL_FRONTDOOR : process.env.REACT_APP_PRICER_API_BASE_URL;

export default function useBatchStatusApi() {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [result, setResult] = useState(null);
	const { accounts, instance } = useMsal();
	const account = useAccount(accounts[0]);

    useEffect(() => {
        if (!account) {
            return;
        }

        let timeoutHandle = undefined;
        const executeRequestLoop = async () => {
            setLoading(true);
            setError(undefined);

            try {
                const { data } = await (await getAuthenticatedClient({
                    url: `${BASE_URL}/status/batches`,
                    method: 'GET',
                    account,
                    msalInstance: instance
                }));
                
                setResult(data);
                timeoutHandle = setTimeout(executeRequestLoop, 20000);
            } catch (e) {
                setError(e);
                timeoutHandle = setTimeout(executeRequestLoop, 40000);
            } finally {
                setLoading(false);
            }
        };

        executeRequestLoop();

        return () => {
            if (timeoutHandle) {
                clearTimeout(timeoutHandle);
            }
        }
    }, [account]);

    

    return {
        loading,
        error,
        result
    };
}

